import React from "react";
import { Container, Responsive, Header, Button } from "semantic-ui-react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";

class PropiedadesScreen extends React.Component {
  renderInDesktop() {
    return (
      <div>
        <Container
          className="marginTop"
        >
          <Header
            as="h2"
            style={{
              fontSize: "40px",
              color: "#5aa7d1",
              marginBottom: "40px",
              textAlign:"center"
            }}
          >
            Propiedades
          </Header>

          <div
            className="autoAlign"
            style={{ marginBottom: "2rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px" }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescTop
            }}
            
          />
          <div
            className="autoAlign"
            style={{ marginBottom: "3rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px"  }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescBottom
            }}
            
          />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className="DButton"
              onClick={() => {
                this.props.push("/" + this.props.url + "/propiedades");
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            >
              ¡CONÓCELOS!
            </Button>
          </div>

          <div className="fixMarginBottom" />
        </Container>
      </div>
    );
  }

  renderInTablet() {
    return (
      <div>
        <Container
          textAlign="center"
          className="marginTop"
        >
          <Header
            as="h2"
            style={{
              fontSize: "40px",
              color: "#5aa7d1",
              marginBottom: "40px"
            }}
          >
            Propiedades
          </Header>

          <div
            className="autoAlign"
            style={{ marginBottom: "2rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px" }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescTop
            }}
          />
          <div
            className="autoAlign"
            style={{ marginBottom: "3rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px" }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescBottom
            }}
          />

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className="DButton"
              onClick={() => {
                this.props.push("/" + this.props.url + "/propiedades");
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            >
              ¡CONÓCELOS!
            </Button>
          </div>

          <div className="fixMarginBottom" />
        </Container>
      </div>
    );
  }

  renderInMobile() {
    return (
      <div>
        <Container
          textAlign="center"
          className="marginTop"
        >
          <Header
            as="h2"
            style={{
              fontSize: "1.7rem",
              color: "#5aa7d1",
              marginBottom: "25px"
            }}
          >
            Propiedades
          </Header>
          <div
            className="autoAlign"
            style={{ marginBottom: "2rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px" }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescTop
            }}
          />
          <div
            className="autoAlign"
            style={{ marginBottom: "3rem", fontFamily:"Lato", fontWeight:300,fontSize:"18px" }}
            dangerouslySetInnerHTML={{
              __html: this.props.propData.propertysDescBottom
            }}
          />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className="DButton"
              onClick={() => {
                this.props.push("/" + this.props.url + "/propiedades");
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            >
              ¡CONÓCELOS!
            </Button>
          </div>
          <div className="fixMarginBottom" />
        </Container>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};
export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(PropiedadesScreen)
);
